import { render, staticRenderFns } from "./DialogVoucher.vue?vue&type=template&id=6838efbc&lang=pug"
import script from "./DialogVoucher.vue?vue&type=script&lang=js"
export * from "./DialogVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports